<template>
  <div class="pageBox">
	<Header current='souye' ref="Header"></Header>
	<div style="height:56px;"></div>
	<div class="cener">
		<div class="detail">
			<div class="detailOne">{{detail.title}}</div>
			<div class="detailTwo">{{detail.publish_time}}</div>
			<div class="detailThree" v-html="detail.content">
				{{detail.content}}
			</div>
		</div>
	</div>
	<Footer></Footer>
  </div>
</template>

<script>
	import Header from "@/components/header.vue"
	import Footer from "@/components/footer.vue"
	import {
		get_read
	} from "@/api/news.js"
  export default {
    components: {
		Header,
		Footer
    },
    data() {
      return {
		id:'',
		detail:''
      }
    },
    mounted() {
		this.$refs.Header.headerHover=true;
		this.$refs.Header.headerTrue=true;
		this.id=this.$route.query.id;
		this.getDetail();
    },
    methods: {
		getDetail(){
			let data={
				id:this.id
			}
			get_read(data).then(res=>{
				console.log(res)
				this.detail=res.data.info
				if(this.detail.content){
					let content = this.detail.content;
						content = content.replace(/\<img/gi, '<img style="width:auto;height:auto;max-width:100%;"').replace(/\<div/gi, '<div style="white-space:normal;"').replace(/\<p/gi, '<p style="white-space:normal;"');
					this.detail.content=content;
				}else{
					this.detail.content='--';
				}
				
			}).catch(err=>{
				console.log(err)
			})
		}
    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.pageBox{
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	// max-width: 677px;
	.cener{
		flex: 1;
		min-height: 500px;
		.detail{
			max-width: 677px;
			// width: 1200px;
			margin: 0 auto;
			padding-top: 100px;
			.detailOne{
				font-size: 24px;
				color: #000;
				text-align: left;
				font-weight: bold;
			}
			.detailTwo{
				font-size: 14px;
				color: #727272;
				text-align: left;
				margin: 10px 0 0;
				border-bottom: 1px solid #eee;
				margin-bottom: 40px;
				padding-bottom: 20px;
			}
			.detailThree{
				img{
					width: 100% !important;
				}
			}
		}
	}
}
	@media screen and (max-width:1200px) {
		.detail{
			padding: 30px !important;
			.detailOne{
				font-size: 18px !important;
			}
		}
	}
</style>
